import React, { Component } from "react";
import dataanalytics from "./da.jpg";
export default class DataScienceImg extends Component {
  render() {
    return <img src={dataanalytics} alt=""></img>;
  }
}
